ProjectPart.$inject = ['$resource'];

const apiUri = '/api/project_part_navigation';

export function ProjectPart($resource) {
  return $resource(
    '/api/',
    {},
    {
      getSvg: { method: 'GET', url: apiUri + '/:id' },
      getProjectParts: {
        method: 'GET',
        url: apiUri + '/:id/parts',
        isArray: true,
      },
    },
  );
}
